import Switch from "@components/ui/switch";
import { cn } from "@lib/cn";
import { useAnalyticsStoreShallow } from "@pages/analytics/store";

export const VersionsUnreadToggle = ({ isMobile }: { isMobile?: boolean }) => {
  const { showUnread, setShowUnread } = useAnalyticsStoreShallow((s) => ({
    showUnread: s.showUnread,
    setShowUnread: s.setShowUnread,
  }));
  return (
    <div
      className={cn(
        "tw-p-2",
        isMobile && "tw-hidden -md:tw-block",
        !isMobile && "-md:tw-hidden",
      )}
    >
      <Switch>
        <Switch.Label className="tw-text-sm tw-font-sans tw-text-blue tw-mr-2">
          Show unread
        </Switch.Label>
        <Switch.Toggle checked={showUnread} onCheckedChange={setShowUnread} />
      </Switch>
    </div>
  );
};
